import { render } from "./ManualTab.vue?vue&type=template&id=337ca3a2"
import script from "./ManualTab.vue?vue&type=script&lang=js"
export * from "./ManualTab.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src996785304/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__